import { lazy, Suspense, useCallback, useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { CallAPI } from "../utils/apiActions";
import { CMS_BASE_URL, TOTAL_SUBSCRIBERS } from "../utils/APIEndPoints";
import useAuth from "../hooks/useAuth";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import FullPageLoader from "../components/UI/FullPageLoader";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";

const TrustedBusiness = lazy(() => import("../components/TrustedBusiness"));
const EngageCustomer = lazy(() => import("../components/EngageCustomer"));
const BuiltIndustry = lazy(() => import("../components/BuiltIndustry"));
const CustomerSuccess = lazy(() => import("../components/CustomerSuccess"));
const FourSteps = lazy(() => import("../components/FourSteps"));
const CustomerExperienceCTA = lazy(
  () => import("../components/CustomerExperienceCTA"),
);
const Home = () => {
  const navigate = useNavigate();
  const { companyInfo, isRazorPayStart } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const parentAgency = searchParams.get("agency") || null;
  const [count, setCount] = useState(0);
  const [tab, setTab] = useState("1");
  const [showModal, setShowModal] = useState(false);

  const [siteVideoLnk, setSiteVideoLnk] = useState({
    fileType: "",
    fileLink: "",
  });

  const fetchDocument = useCallback(async () => {
    let url3 = `${CMS_BASE_URL.CMS.GET_ALL}17`;
    const response = await CallAPI("USER", "POST", url3, {});
    console.log(response?.res?.data?.data?.cmsData[0]);
    if (
      response?.res?.data?.data?.cmsData &&
      Array.isArray(response?.res?.data?.data?.cmsData) &&
      Array.isArray(response?.res?.data?.data?.cmsData[0]?.files)
    ) {
      let file = response?.res?.data?.data?.cmsData[0].files[0];
      // console.log(file.fileType);
      let value = { fileType: file.fileType, fileLink: file.fileLink };

      setSiteVideoLnk(value);
    }
  }, []);
  console.log(siteVideoLnk, "siteVideoLnk");

  useEffect(() => {
    fetchDocument();
  }, [location]);

  useEffect(() => {
    getTotalSubscriberCount();
  }, [companyInfo?.logo]);

  const getTotalSubscriberCount = async () => {
    let data = parentAgency ? { agencyId: parentAgency } : {};
    let response = await CallAPI("USER", "POST", TOTAL_SUBSCRIBERS, data);
    setCount(response?.res?.data?.data || 0);
  };

  const statsData = [
    { label: "Users", value: 3000 },
    { label: "Messages", value: 22 },
    { label: "Agents", value: 300 },
    { label: "Referred", value: 200 },
  ];

  return (
    <section className="body-wrap">
      {/* {isRazorPayStart && <FullPageLoader />} */}

      <div className="home-banner new-banner">
        <div className="container">
          <div className="home-banner_wrap">
            <div className="left-div">
              <span className="heading-tag">
                <i className="fa-solid fa-sparkles"></i> AI-Powered Customer
                Engagement
              </span>
              <h1>Beyond Chat: Intelligent AI for Any Website</h1>
              <p>
                Deploy AI that understands context, analyzes sentiment, and
                equips your clients with a chatbot that's smart enough to handle
                every interaction just like you and provides deep analytics.
              </p>

              <div className="group-btn">
                <Link to="/signup" className="cta-primary with-animation">
                  Get Started for Free{" "}
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>
                <a
                  href="#"
                  className="cta-border"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowModal(true);
                  }}
                >
                  <i className="fa-regular fa-play"></i> Watch Demo
                </a>
              </div>

              <div className="business-rating">
                <div className="business-trust">
                  <div className="business-trust-img">
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                    <div className="box"></div>
                  </div>
                  <div className="business-trust-text">
                    <p>100+ Businesses</p>
                    <p>Trust BottBuddy</p>
                  </div>
                </div>
                <div className="rating-review">
                  <div className="rating">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </div>
                  <div>4.9/5 Rating</div>
                  <div className="grey-text">From 500+ Reviews</div>
                </div>
              </div>
            </div>

            <div className="right-div">
              <div className="banner-chat">
                <div className="banner-chat_head">
                  <div className="icon-block">
                    <i className="fa-light fa-comment"></i>
                  </div>
                  <div className="flex-1">
                    <div className="chat-titla">BottBuddy Assistant</div>
                    <div className="chat-online">
                      <div className="online-active animate-fade"></div>
                      Online
                    </div>
                  </div>
                </div>

                <div className="banner-chat_body">
                  <div
                    className="msg left"
                    role="article"
                    aria-label="assistant message"
                  >
                    <div className="avatar" aria-hidden="true"></div>
                    <div>
                      <div className="msg-textbox">
                        Hi! How can I help you today?
                      </div>
                    </div>
                  </div>

                  <div
                    className="msg right"
                    role="article"
                    aria-label="your message"
                  >
                    <div className="msg-textbox">I need help with pricing</div>
                  </div>

                  <div
                    className="msg left"
                    role="article"
                    aria-label="assistant message with actions"
                  >
                    <div className="avatar" aria-hidden="true"></div>
                    <div>
                      <div className="msg-textbox">
                        I'd be happy to help! We have flexible plans for every
                        need:
                      </div>
                      <div className="pills">
                        <div className="pill">View Pricing</div>
                        <div className="pill">Free Trial</div>
                        <div className="pill">Talk to Sales</div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="msg left typing"
                    role="status"
                    aria-live="polite"
                  >
                    <div className="avatar" aria-hidden="true"></div>
                    <div className="msg-textbox">
                      <div className="dots" aria-hidden="true">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="banner-chat_footer">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Type your message..."
                    disabled=""
                  ></input>
                  <button className="cta-primary">Send</button>
                </div>
              </div>
              <div className="responce-rate animate-fade">
                <p>98% Response Rate</p>
                <div className="groth-month">
                  <i className="fa-regular fa-chart-line-up"></i>
                  <p>+24% this month</p>
                </div>
              </div>
              <div className="avg-response">
                <figure>
                  <svg
                    className="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    ></path>
                  </svg>
                </figure>
                <div className="">
                  <p>Avg Response</p>
                  <p>2.3 seconds</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Suspense fallback={null}>
        <EngageCustomer />
      </Suspense>

      <Suspense fallback={null}>
        <TrustedBusiness />
      </Suspense>

      <Suspense fallback={null}>
        <BuiltIndustry />
      </Suspense>

      {/* section 1 */}
      <Suspense fallback={null}>
        <CustomerSuccess />
      </Suspense>
      {/* section 1 end*/}
      {/* section 2 */}
      <Suspense fallback={null}>
        <FourSteps />
      </Suspense>
      {/* section 2 end */}
      {/* section 3 */}
      <Suspense fallback={null}>
        <CustomerExperienceCTA />
      </Suspense>
      {/* section 3 end */}
      {/* section 4 */}
      <div className="home-banner none">
        <div className="container">
          <div className="home-banner_text">
            <h1>Beyond Chat: Intelligent AI for Any Website.</h1>
            <h6>
              Deploy AI that understands context, analyzes sentiment. Equip your
              clients with a chatbot that is smart enough to handle every
              interaction just like you and provides deep analytics.
            </h6>
            <div className="group-btn">
              <a href="/login" className="cta-primary">
                Get Started
              </a>
              <a href="/login" className="text-link">
                Learn How It Works
              </a>
            </div>
          </div>
        </div>

        <div className="home-banner_height"></div>

        <div className="gbl-mar ai-comm_wrap">
          <div className="container sum-med">
            <div className="ai-comm_head">
              <h3>AI Communication Made Simple, Scalable & Secure</h3>
              <p>
                Build and resell AI bots with ease. Earn ongoing revenue from
                referrals—fully compliant with GDPR, and HIPAA standards.
              </p>
            </div>
            <div className="ai-comm_info">
              <ul>
                <li>
                  {/* <figure>
										<img src="/images/aicpa-logo.png" alt="" />
									</figure>
									<p>
										SOC 2
										<img src="/images/blue-tick-icon.svg" alt="" />
									</p> */}
                </li>
                <li>
                  <figure>
                    <img src="/images/gdpr-logo.png" alt="" />
                  </figure>
                  <p>
                    GDPR
                    <img src="/images/blue-tick-icon.svg" alt="" />
                  </p>
                </li>
                <li>
                  <figure>
                    <img src="/images/hipaa-logo.png" alt="" />
                  </figure>
                  <p>
                    HIPAA
                    <img src="/images/blue-tick-icon.svg" alt="" />
                  </p>
                </li>
                <li></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="gbl-mar counter_wrap">
          <div className="container med">
            <h3>Performance Highlights</h3>
            <div className="stats-container">
              {statsData.map((item, index) => (
                <CounterBox key={index} value={item.value} label={item.label} />
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* section 4 end */}
      {/* section 5 */}
      <div className="vert-gradient ai-precision_wrap none">
        <div className="container">
          <div className="ai-precision_head">
            <div className="ai-precision_heading">
              <h2>Craft Your AI Communication Assistant with Precision</h2>
            </div>
            <div className="ai-precision_text">
              <p>
                From visual identity to conversational depth, effortlessly shape
                your chatbot through curated appearance, knowledge, interaction,
                and behavior settings.
              </p>
            </div>
          </div>

          <div className="ai-precision_info">
            <div className="ai-precision_block">
              <figure>
                <img src="/images/ai-precision-img1.png" alt="" />
                <span>1</span>
              </figure>
              <h6>Define the Persona</h6>
              <p>
                Craft your chatbot’s identity with customizable appearance,
                name, and tone of voice.
              </p>
            </div>
            <div className="ai-precision_block with-blue-dot">
              <figure>
                <img src="/images/ai-precision-img2.png" alt="" />
                <span>2</span>
              </figure>
              <h6>Curate the Knowledge</h6>
              <p>
                Upload documents, URLs, or embed content that shapes what your
                chatbot knows.
              </p>
            </div>
            <div className="ai-precision_block with-blue-dot">
              <figure>
                <img src="/images/ai-precision-img3.png" alt="" />
                <span>3</span>
              </figure>
              <h6>Refine the Conversation</h6>
              <p>
                Design the question area and expected interactions to ensure
                relevance and clarity.
              </p>
            </div>
            <div className="ai-precision_block with-blue-dot">
              <figure>
                <img src="/images/ai-precision-img4.png" alt="" />
                <span>4</span>
              </figure>
              <h6>Tune the Experience</h6>
              <p>
                Adjust chat settings response style, behavior rules, and user
                interaction preferences.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* section 5 end */}

      <div className="gbl-mar ai-chattype_wrap none">
        <div className="container">
          <div className="ai-chattype_head">
            <span>Project and long-term planning</span>
            <h3>Smarter Conversations, Evolving AI Communication</h3>
            <p>
              Our platform enables you to provide intelligent support through
              chat today—while future-proofing your brand for the rise of
              voice-powered AI communication.
            </p>
          </div>

          <div className="ai-chattype_info">
            <div className="ai-chattype_block hor-gradient">
              <div className="ai-chattype_text with-blue-dot">
                <h3>Seamless AI Text Chat</h3>
                <p>
                  Launch intelligent conversations instantly with our fully
                  customizable text-based chatbot. From branded appearance to
                  knowledge sourcing and behavior tuning, our AI assistant is
                  built to engage, support, and convert right out of the box.
                </p>
              </div>
              <div className="ai-chattype_img">
                <a href="/login" className="cta-primary">
                  Get Started
                </a>
                <figure>
                  <img src="/images/ai-textchat-img.png" alt="" />
                </figure>
              </div>
            </div>

            <div className="ai-chattype_block hor-gradient">
              <div className="ai-chattype_text with-blue-dot">
                <h3>Voice Chat Evolution</h3>
                <p>
                  We're developing advanced voice capabilities that will allow
                  your users to speak to their AI assistant just like they would
                  to a real person — making support faster, more accessible, and
                  human-like than ever before.
                </p>
              </div>

              <div className="ai-chattype_img">
                <a href="#" className="cta-white2">
                  Coming Soon
                </a>
                <figure>
                  <img src="/images/voice-chat-img.png" alt="" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="gbl-mar short-listinfo_wrap none">
        <div className="container">
          <ul>
            <li className="with-icon">
              <h6>
                <img src="/images/icons/complete-chatbot-icon.svg" alt="" />
                Complete Chatbot Management
              </h6>
              <p>
                Create, edit, and monitor your bots from one place. From
                analytics to contact handling, everything is streamlined for
                ease.
              </p>
            </li>
            <li className="with-icon">
              <h6>
                <img src="/images/icons/advanced-access-icon.svg" alt="" />
                Advanced Access Control
              </h6>
              <p>
                Use Designation & Employee Management to control access and
                maintain security within teams and organizations.
              </p>
            </li>
            <li className="with-icon">
              <h6>
                <img src="/images/icons/human-takeover-icon.svg" alt="" />
                Human Takeover Support
              </h6>
              <p>
                Seamlessly switch from bot to human to provide personal
                responses when needed.
              </p>
            </li>
            <li className="with-icon">
              <h6>
                <img src="/images/icons/subscription-check-icon.svg" alt="" />
                Subscription & Feedback Tools
              </h6>
              <p>
                Monitor your plan usage, submit feedback, and get help instantly
                to enhance your chatbot experience.
              </p>
            </li>
          </ul>
        </div>
      </div>

      <div className="vert-gradient ai-business-solution_wrap none">
        <div className="container">
          <div className="ai-business-solution_head">
            <div className="ai-business-solution_heading">
              <h2>Every Business Problem Has an AI Communication Solution</h2>
            </div>
            <div className="ai-business-solution_text">
              <p>
                Automate tasks across departments with the only all-in-one
                chatbot builder platform designed to streamline your entire
                business.
              </p>
            </div>
          </div>

          {/* <div className="ai-business-solution_tabs">
						<header>
							<ul className="tab-lists">
								<li className={tab == "1" ? "active" : ""} onClick={() => setTab("1")}>Meta Data</li>
								<li className={tab == "2" ? "active" : ""} onClick={() => setTab("2")}>Analytics</li>
								<li className={tab == "3" ? "active" : ""} onClick={() => setTab("3")}>Contacts</li>
							</ul>
						</header>

						{tab === "1" && (
							<div className="tab-content">
								<div id="MetaData" className="pt--40">
									<img src="/images/dashboard-img1.png" alt=""></img>
								</div>
							</div>
						)}

						{tab === "2" && (
							<div className="tab-content">
								<div id="Analytics" className="pt--40">
									<img src="/images/ai-precision-img2.png" alt=""></img>
								</div>
							</div>
						)}

						{tab === "3" && (
							<div className="tab-content">
								<div id="Contacts" className="pt--40">
									<img src="/images/ai-precision-img3.png" alt=""></img>
								</div>
							</div>
						)}
					</div> */}
        </div>
      </div>

      <div className="gbl-mar industry-slider_wrap none">
        <div className="container">
          <div className="gbl-head industry-slider_head">
            <h3>Suitable for every industry</h3>
            <p>
              No matter what the industry, Botbuddy lets your business thrive
              easily.
            </p>
          </div>
          <div className="industry-slider_slider">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              autoplay={{
                delay: 3000, // 3 seconds between slides
                disableOnInteraction: false, // keeps autoplay after user interaction
              }}
              navigation={true}
              pagination={false}
              spaceBetween={50}
              slidesPerView={5}
              onSlideChange={() => console.log("slide change")}
              // onSwiper={(swiper) => console.log(swiper)}
              breakpoints={{
                340: {
                  slidesPerView: 1,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
              // loop={true}
            >
              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="industry-slide_card">
                    <figure>
                      <img
                        src="/images/industry-slide-img1.png"
                        alt="mask image"
                      />
                    </figure>
                    <h5>Education</h5>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="industry-slide_card">
                    <figure>
                      <img
                        src="/images/industry-slide-img2.png"
                        alt="mask image"
                      />
                    </figure>
                    <h5>Ecommerce</h5>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="industry-slide_card">
                    <figure>
                      <img
                        src="/images/industry-slide-img3.png"
                        alt="mask image"
                      />
                    </figure>
                    <h5>Real Estate</h5>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="industry-slide_card">
                    <figure>
                      <img
                        src="/images/industry-slide-img1.png"
                        alt="mask image"
                      />
                    </figure>
                    <h5>Education</h5>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="industry-slide_card">
                    <figure>
                      <img
                        src="/images/industry-slide-img2.png"
                        alt="mask image"
                      />
                    </figure>
                    <h5>Ecommerce</h5>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="industry-slide_card">
                    <figure>
                      <img
                        src="/images/industry-slide-img3.png"
                        alt="mask image"
                      />
                    </figure>
                    <h5>Real Estate</h5>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>

      <div className="gbl-mar testimonial-slider_wrap none">
        <div className="container">
          <div className="testimonial-slider_slider">
            <Swiper
              modules={[Navigation, Pagination]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              navigation={false}
              pagination={{ clickable: true }} // ✅ bullet click works now
              spaceBetween={30}
              slidesPerView={5}
              onSlideChange={() => console.log("slide change")}
              // onSwiper={(swiper) => console.log(swiper)}
              breakpoints={{
                340: {
                  slidesPerView: 1,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 2,
                },
              }}
              // loop={true}
            >
              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="testimonial-slider_card">
                    <img src="/images/quote-icon.svg" alt="mask image" />
                    <h6>Complete Chatbot Management Made Easy</h6>
                    <p>
                      The central dashboard brings everything—analytics,
                      contacts, metadata—into one intuitive space. It's a
                      game-changer for managing multiple chatbots without
                      switching tabs.
                    </p>

                    <div className="customer-info">
                      <figure>
                        <img src="/images/images-100.png" alt="mask image" />
                      </figure>
                      <aside>
                        <h6>Supriya Bose</h6>
                        <span>General Manager</span>
                      </aside>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="testimonial-slider_card">
                    <img src="/images/quote-icon.svg" alt="mask image" />
                    <h6>Secure and Scalable Access Control</h6>
                    <p>
                      The Designation and Employee Management modules allowed us
                      to assign roles with ease. We trust this system for its
                      secure, tiered access—perfect for larger teams.
                    </p>

                    <div className="customer-info">
                      <figure>
                        <img src="/images/images-100.png" alt="mask image" />
                      </figure>
                      <aside>
                        <h6>Anirban Dey</h6>
                        <span>Business Administrator</span>
                      </aside>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="testimonial-slider_card">
                    <img src="/images/quote-icon.svg" alt="mask image" />
                    <h6>Insightful Performance Analytics</h6>
                    <p>
                      The analytics dashboard provides clear visibility into
                      chat volume, user satisfaction, and response accuracy.
                      Having all metrics in one place helps us continuously
                      improve our bots’ efficiency.
                    </p>

                    <div className="customer-info">
                      <figure>
                        <img src="/images/images-100.png" alt="mask image" />
                      </figure>
                      <aside>
                        <h6>Disha Sen</h6>
                        <span>Senior Manager</span>
                      </aside>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="swiper-slide">
                  <div className="testimonial-slider_card">
                    <img src="/images/quote-icon.svg" alt="mask image" />
                    <h6>Seamless Bot Training and Updates</h6>
                    <p>
                      Updating chatbot responses used to be a tedious task. With
                      the new training module, refining intents and adding
                      Prompts and QnAs feels effortless. The real-time preview
                      ensures every tweak delivers instant results.
                    </p>

                    <div className="customer-info">
                      <figure>
                        <img src="/images/images-100.png" alt="mask image" />
                      </figure>
                      <aside>
                        <h6>Susmita Roy</h6>
                        <span>Delivery Manager</span>
                      </aside>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>

      <div className="book-demo_wrap none">
        <div className="container">
          <div className="book-demo_box">
            <h3>Solve 80% of customer queries with AI Chatbot</h3>
            <a href="/login" className="cta-white2">
              Book a Demo
            </a>
          </div>
        </div>
      </div>

      <Dialog
        className="demo-dialog video-modal"
        fullWidth={true}
        maxWidth={"xl"}
        open={showModal}
        onClose={() => setShowModal(false)}
      >
        <DialogActions className="video-modal-close">
          <Button
            onClick={() => setShowModal(false)}
            style={{
              zIndex: 99999,
              background: "#000000a1",
              padding: "4px",
              borderRadius: "4px",
            }}
          >
            <img src="/images/cross-icon-b.png" alt="Close Modal" />
          </Button>
        </DialogActions>
        <DialogContent sx={{ p: { xs: "12px", sm: "16px", md: "20px" } }}>
          {/*<DialogContentText>
            You can set my maximum width and whether to adapt or not.
          </DialogContentText>*/}
          <Box
            noValidate
            component="form"
            sx={{
              display: "flex",
              flexDirection: "column",
              m: "auto",
              width:
                siteVideoLnk.fileType == "youtube" ? "100%" : "fit-content",
            }}
          >
            {siteVideoLnk.fileType == "youtube" ? (
              <div
                className="video-block"
                dangerouslySetInnerHTML={{ __html: siteVideoLnk.fileLink }}
              />
            ) : (
              <video
                //   controls={false}
                autoPlay
                src={siteVideoLnk.fileLink}
              />
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Home;

const CounterBox = ({ value, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = value;
    const duration = 2000; // 2 seconds
    const stepTime = 20;
    const increment = end / (duration / stepTime);

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <div className="stat-card">
      <h2>
        {count.toLocaleString()}
        <span className="plus">+</span>
      </h2>
      <p>{label}</p>
    </div>
  );
};
